<template>
  <div class="file" v-if="isShow">
    <!--<div class="file-pop">-->
    <!--<span class="icontemp stemp-close" @click="close()"></span>-->
    <!--<ul class="data-list">-->
    <!--<li v-for="(f, i) in fileList" :key="i" @click="download(f)">-->
    <!--<img class="icon1" :src="getFileType(f.ext)" alt="" />-->
    <!--<div class="name">{{ f.name }}</div>-->
    <!--<span class="icontemp download-a"></span>-->
    <!--</li>-->
    <!--</ul>-->
    <!--</div>-->
    <div class="file-box">
      <div class="file-header">
        资料下载
        <span class="icontemp stemp-close" @click="close()"></span>
      </div>

      <div class="file-list">
        <GeminiScrollbar :autoshow="true" class="my-scroll-bar">
          <div class="file-item" v-for="(f, i) in fileList" :key="i">
            <div class="file-icon"></div>
            <div class="file-name">{{ f.name }}</div>
            <div class="file-down" @click="download(f)">
              <span class="icontemp download-a"></span>
            </div>
          </div>
        </GeminiScrollbar>
      </div>

      <div class="file-downAll"></div>
    </div>
  </div>
</template>

<script>
import { buildFlieData, buildTableMethod, mounted } from "../../common/file";
export default {
  name: "File",
  data() {
    return buildFlieData({});
  },
  methods: buildTableMethod({
    getFileType(ext) {
      let type = "";
      if (
        [
          "jpg",
          "gif",
          "png",
          "bmp",
          "pdf",
          "ppt",
          "mp3",
          "pptx",
          "doc",
          "docx",
          "xls",
          "xlsx",
          "zip",
          "rar"
        ].includes(ext)
      ) {
        type = ext;
      } else {
        type = "other";
      }
      return require("../../assets/images/f-" + type + ".png");
    }
  }),
  created() {
    mounted(this);
  }
};
</script>

<style scoped></style>
